import MapsList from './MapsList'

export default MapsList
